function cssClear() {
	const html = document.querySelector('html')
	const body = document.querySelector('body')
	html.removeAttribute('style')
	body.removeAttribute('style')
}

export { cssClear }